"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IHttpApi.js.map